import React, { useState, useRef } from "react";
import { AnimatePresence, motion } from "framer-motion";
import PropTypes from "prop-types";

const SiteSearch = ({lang}) => {
	const [isSearchOpen, setIsSearchOpen] = useState(false);
	const inputRef = useRef(null);

	const renderIcon = (icon) => (
		<img
			src={`${mainScript.assetPath}images/svg/icons/icon-${icon}.svg`}
			alt=""
		/>
	);

	const translatePlaceholder = (language) => {
		if (language === "fr-FR") return 'Rechercher';
		return "Search";
	}

	const actionUrl = (language) => {
		if (language === "fr-FR") return '/fr/';
		return "/";
	}

	const toggleSearch = () => setIsSearchOpen((currentValue) => !currentValue);

	const focusInput = () => inputRef.current.focus();

	return (
		<div className="search-element">
			<button
				aria-label="Open search input"
				className="search-element__open-btn"
				onClick={toggleSearch}
				type="button"
			>
			</button>
			<AnimatePresence>
				{isSearchOpen && (
					<motion.form
						className="search-element__form"
						role="search"
						action={actionUrl(lang)}
						method="get"
						initial={{ width: 0, opacity: 0 }}
						animate={{ width: "100%", opacity: 1 }}
						exit={{ width: 0, opacity: 0 }}
						transition={{
							width: { duration: 0.5 },
						}}
						onAnimationComplete={focusInput}
					>
						<div className="search-element__input-container">
							<div className="search-element__icon">{renderIcon("search")}</div>
							<label htmlFor="search">Enter your search</label>
							<input
								id="search"
								ref={inputRef}
								type="text"
								name="s"
								placeholder={translatePlaceholder(lang)}
								className="search-element__input"
							/>
							<button
								onClick={toggleSearch}
								aria-label="close search input"
								className="search-element__close-btn"
								type="button"
							>
								{renderIcon("close")}
							</button>
						</div>
					</motion.form>
				)}
			</AnimatePresence>
		</div>
	);
};

export default SiteSearch;

SiteSearch.propTypes = {
	lang: PropTypes.string,
}